import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "colorSet", "children"];
import React from 'react';
import { spacer24, spacer64 } from '@spotify-internal/encore-foundation';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet, cssSpacing, defaultTheme, overflowWrapFlexText, rootStyle, zIndexFixed } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
export var Wrapper = styled.div.withConfig({
  displayName: "UnsupportedBrowser__Wrapper",
  componentId: "sc-9pnsws-0"
})(["", ";color:var(--text-base,", ");background-color:var(--background-base,", ");position:fixed;top:0;bottom:0;left:0;inline-size:100%;z-index:", ";display:flex;flex-direction:column;text-align:center;overflow:auto;", ";"], rootStyle(), defaultTheme.invertedDark.text.base, defaultTheme.invertedDark.background.base, zIndexFixed, overflowWrapFlexText());
var BodyWrapper = styled.div.withConfig({
  displayName: "UnsupportedBrowser__BodyWrapper",
  componentId: "sc-9pnsws-1"
})(["box-sizing:border-box;display:flex;flex-direction:column;max-inline-size:100%;max-block-size:100%;padding:", ";margin:auto;*{margin:auto;}"], cssSpacing('looser', spacer24));
var BodySvg = styled.svg.withConfig({
  displayName: "UnsupportedBrowser__BodySvg",
  componentId: "sc-9pnsws-2"
})(["stroke:var(--background-base,", ");margin-block-end:", ";flex-shrink:0;[dir='rtl'] &{transform:scaleX(-1);}"], defaultTheme.invertedDark.background.base, cssSpacing('looser-4', spacer64));
/**
 * @deprecated
 * This component is deprecated and will be archived in a future release.
 */
/**
* **UnsupportedBrowser** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/UnsupportedBrowser) 
*
* UnsupportedBrowser shows a simple message and image when a browser is unsupported.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/unsupported-browser)
*
* @example
* () => (
*  <UnsupportedBrowser>
*    <Type as="p" variant="altoBrio">
*      Your browser doesn’t work with this application.
*    </Type>
*    <Type paddingBottom="0.67em" as="p" variant="altoBrio">
*      <TextLink href="https://browser-update.org/" standalone>
*        Switch or update browsers.
*      </TextLink>
*    </Type>
*  </UnsupportedBrowser>
*);
*
*/
export var UnsupportedBrowser = function UnsupportedBrowser(_ref) {
  var className = _ref.className,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'invertedDark' : _ref$colorSet,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Wrapper, Object.assign({}, props, {
    className: addColorSet(colorSet, className),
    "data-encore-id": ENCORE_DATA_IDS.UnsupportedBrowser
  }), /*#__PURE__*/React.createElement(BodyWrapper, null, /*#__PURE__*/React.createElement(BodySvg, {
    role: "img",
    width: "214",
    height: "155",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFF",
    strokeWidth: "3",
    x: "1.5",
    y: "1.5",
    width: "211",
    height: "152",
    rx: "9"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: "16",
    cy: "18",
    r: "4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: "32",
    cy: "18",
    r: "4"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: "48",
    cy: "18",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 83c3.28 2.667 7.28 4 12 4s8.72-1.333 12-4M135 83c3.28 2.667 7.28 4 12 4s8.72-1.333 12-4",
    stroke: "#FFF",
    strokeWidth: "3",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 122.374c13-4.25 26-6.374 39-6.374s26 2.125 39 6.374M2.5 34.5h210",
    stroke: "#FFF",
    strokeWidth: "3",
    strokeLinecap: "square"
  })), children));
};